import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Grid, Box } from '@mui/material'
import moment from 'moment'
import clsx from 'clsx'
import { withStyles } from '~/themes/useStyles'
import DayPicker from '~/components/common/DayPicker'
import TimeSelect from '~/components/common/TimeSelect'
import style from './style'

const DateTimeInput = ({
  value,
  onChange,
  inputFormat,
  disabled,
  error,
  onBlur,
  name,
  helperText,
  classes,
  minimumDate,
  timeSelectProps,
}) => {
  const dateValue = useMemo(
    () => (value ? moment(value, inputFormat).format('MM/DD/YYYY') : ''),
    [value],
  )
  const timeValue = useMemo(
    () => (value ? moment(value, inputFormat).format('hh:mm A') : ''),
    [value],
  )

  const onChangeDate = (newDate) => {
    onChange(
      moment(
        `${newDate} ${timeValue || '12:00 AM'}`,
        'MM/DD/YYYY hh:mm A',
      ).format(inputFormat),
    )
  }

  const onChangeTime = (e) => {
    const newVal = e.target.value || '12:00 AM'
    const date = dateValue || moment().format('MM/DD/YYYY')
    onChange(
      moment(`${date} ${newVal}`, 'MM/DD/YYYY hh:mm A').format(inputFormat),
    )
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid xs={6} item>
          <DayPicker
            disabled={disabled}
            value={dateValue}
            onChange={onChangeDate}
            error={error}
            minimumDate={minimumDate}
            disablePastDate
            inputProps={{
              name,
              error,
              onBlur,
            }}
          />
        </Grid>
        <Grid xs={6} item className={classes.timeContainer}>
          <TimeSelect
            disabled={disabled}
            className={clsx(classes.handlePadding, classes.timesCheck)}
            hasPeriods={false}
            value={timeValue}
            onChange={onChangeTime}
            error={error}
            onBlur={onBlur}
            name={name}
            {...timeSelectProps}
          />
        </Grid>
      </Grid>
      {!!helperText && !!error ? (
        <Box>
          <p
            style={{
              color: '#F64066',
              fontSize: 12,
              marginTop: 4,
              marginLeft: 3,
            }}
          >
            {helperText}
          </p>
        </Box>
      ) : (
        ''
      )}
    </>
  )
}

DateTimeInput.defaultProps = {
  value: '',
  onChange: () => {},
  inputFormat: 'YYYY-MM-DDTHH:mm:ss',
  disabled: false,
  error: false,
  onBlur: () => {},
  name: '',
  helperText: '',
  minimumDate: '',
  timeSelectProps: {},
}

DateTimeInput.propTypes = {
  classes: PropTypes.shape().isRequired,
  timeSelectProps: PropTypes.shape({}),
  value: PropTypes.string,
  onChange: PropTypes.func,
  inputFormat: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  onBlur: PropTypes.func,
  name: PropTypes.string,
  helperText: PropTypes.string,
  minimumDate: PropTypes.string,
}

export default withStyles(style)(DateTimeInput)
